import React from "react";

const NextArrow = () => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
      >
        <g clipPath="url(#clip0_541_1545)">
          <path
            d="M20 0C8.97219 0 0 8.97219 0 20C0 31.0278 8.97219 40 20 40C31.0278 40 40 31.0278 40 20C40 8.97219 31.0278 0 20 0ZM20 37.5C10.3503 37.5 2.5 29.6497 2.5 20C2.5 10.3503 10.3503 2.5 20 2.5C29.6497 2.5 37.5 10.3503 37.5 20C37.5 29.6497 29.6497 37.5 20 37.5ZM28.3838 19.1163C28.8722 19.6047 28.8722 20.3956 28.3838 20.8838L22.1338 27.1338C21.8897 27.3778 21.5697 27.5 21.25 27.5C20.9303 27.5 20.6103 27.3778 20.3662 27.1338C19.8778 26.6453 19.8778 25.8544 20.3662 25.3662L24.4825 21.25H12.5C11.8097 21.25 11.25 20.6909 11.25 20C11.25 19.3091 11.8097 18.75 12.5 18.75H24.4825L20.3662 14.6337C19.8778 14.1453 19.8778 13.3544 20.3662 12.8663C20.8547 12.3781 21.6456 12.3778 22.1338 12.8663L28.3838 19.1163Z"
            fill="#1E5EFF"
          />
        </g>
        <defs>
          <clipPath id="clip0_541_1545">
            <rect width="40" height="40" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};

export default NextArrow;
